export default {
  init () {
    return new Promise(function (resolve, reject) {
      window.onload = function () {
        // eslint-disable-next-line no-undef
        resolve('')
      }
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://ssl.captcha.qq.com/TCaptcha.js'
      script.onerror = reject
      document.head.appendChild(script)
      console.log('bdfse')
      // eslint-disable-next-line no-undef
    })
  },
  showCaptchaView (width, lang = 'zh-cn', sCallback, eCallback) {
    // 初始化
    // eslint-disable-next-line no-undef,no-new
    var captcha = new TencentCaptcha('2042888179', (res) => {
      console.log(res)
      if (res.ret === 2) {
        console.log(eCallback)
        eCallback &&
        eCallback({
          error: 1007,
          msg: '退出验证'
        })
      } else if (res.ret === 0) {
        sCallback &&
        sCallback({
          ticket: res.ticket,
          rand: res.randstr
        })
      }
    }, {
      needFeedBack: false,
      userLanguage: lang
    })
    captcha.show()

    // new YpRiddler({
    //   expired: 10,
    //   mode: 'flat',
    //   winWidth: width,
    //   lang: 'zh-cn', // 界面语言, 目前支持: 中文简体 zh-cn, 英语 en
    //   // langPack: LANG_OTHER, // 你可以通过该参数自定义语言包, 其优先级高于lang
    //   container: document.getElementById('bindYp'),
    //   appId: '928e457525f94853a0392dfeafac73ef',
    //   version: 'v1',
    //   onError: function(param) {
    //     if (!param.code) {
    //       eCallback &&
    //         eCallback({
    //           error: 1001,
    //           msg: '错误请求'
    //         })
    //     } else if (parseInt(param.code / 100) === 5) {
    //       // 服务不可用时，开发者可采取替代方案
    //       eCallback &&
    //         eCallback({
    //           error: 1002,
    //           msg: '验证服务暂不可用'
    //         })
    //     } else if (param.code === 429) {
    //       eCallback &&
    //         eCallback({
    //           error: 1003,
    //           msg: '请求过于频繁，请稍后再试'
    //         })
    //     } else if (param.code === 403) {
    //       eCallback &&
    //         eCallback({
    //           error: 1004,
    //           msg: '请求受限，请稍后再试'
    //         })
    //     } else if (param.code === 400) {
    //       eCallback &&
    //         eCallback({
    //           error: 1005,
    //           msg: '非法请求，请检查参数'
    //         })
    //     }
    //     // 异常回调
    //     console.error('验证服务异常')
    //   },
    //   onSuccess: function(validInfo, close, useDefaultSuccess) {
    //     sCallback &&
    //       sCallback({
    //         token: validInfo.token,
    //         authenticate: validInfo.authenticate
    //       })
    //     // 验证成功默认样式
    //     useDefaultSuccess(true);
    //     close()
    //   },
    //   onFail: function(code, msg, retry) {
    //     eCallback &&
    //       eCallback({
    //         error: 1006,
    //         msg: '回调失败'
    //       })
    //     retry()
    //   },
    //   beforeStart: function(next) {
    //     next()
    //   },
    //   onExit: function() {
    //     // eslint-disable-next-line prefer-promise-reject-errors
    //     eCallback &&
    //       eCallback({
    //         error: 1007,
    //         msg: '退出验证'
    //       })
    //   }
    // })
  }
}



// WEBPACK FOOTER //
// ./src/components/Captcha/src/Captcha.js